/* KOBRE storefront interactions. Shopify remains authoritative for checkout and inventory. */
(() => {
  'use strict';

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const configElement = document.getElementById('kobre-config');
  const config = configElement ? JSON.parse(configElement.textContent) : {};

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: config.CURRENCY || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return `$${amount.toFixed(2)}`;
    }
  }

  /* Product gallery */
  let activeImage = 0;
  const track = $('[data-gallery-track]');

  function setImage(index) {
    if (!track) return;
    const count = track.children.length;
    if (!count) return;
    activeImage = (index + count) % count;
    track.scrollTo({
      left: activeImage * track.clientWidth,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    syncImage();
  }

  function syncImage() {
    if (!track) return;
    activeImage = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    $$('[data-thumb]').forEach((button, index) => {
      const selected = index === activeImage;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    const count = $('[data-gallery-count]');
    if (count) count.textContent = `${String(activeImage + 1).padStart(2, '0')} / ${String(track.children.length).padStart(2, '0')}`;
  }

  track?.addEventListener('scroll', syncImage, { passive: true });

  /* Main click interactions */
  document.addEventListener('click', event => {
    const target = event.target;

    const thumb = target.closest('[data-thumb]');
    if (thumb) setImage(Number(thumb.dataset.thumb));

    const slide = target.closest('[data-slide]');
    if (slide) setImage(activeImage + Number(slide.dataset.slide));

    const zoom = target.closest('[data-zoom-src]');
    if (zoom) {
      const image = $('#lightbox-image');
      if (image) {
        image.src = zoom.dataset.zoomSrc;
        image.alt = zoom.dataset.alt || 'KOBRE Mini Sub';
      }
      $('#photo-lightbox')?.classList.remove('is-zoomed');
      openDialog($('#photo-lightbox'));
    }

    if (target.closest('[data-toggle-zoom]')) $('#photo-lightbox')?.classList.toggle('is-zoomed');
    if (target.closest('[data-close-dialog]')) closeDialog(target.closest('dialog'));

    const quantityButton = target.closest('[data-quantity]');
    if (quantityButton) {
      const control = quantityButton.closest('.quantity-control');
      const input = control ? $('input', control) : null;
      if (input) {
        const min = Number(input.min) || 1;
        const max = Number(input.max) || 99;
        const next = (Number(input.value) || min) + Number(quantityButton.dataset.quantity || 0);
        input.value = Math.max(min, Math.min(max, next));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const menu = target.closest('[data-menu-toggle]');
    if (menu) {
      const expanded = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!expanded));
      const mobileNav = $('#mobile-nav');
      if (mobileNav) mobileNav.hidden = expanded;
    }

    if (target.closest('.mobile-nav a')) {
      const mobileNav = $('#mobile-nav');
      if (mobileNav) mobileNav.hidden = true;
      $('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    }

    const trackingLink = target.closest('[data-open-tracking]');
    if (trackingLink) {
      event.preventDefault();
      openDialog($('#order-tracking'));
    }
  });

  $$('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) closeDialog(dialog);
    });
  });



  /* Live viewer activity: randomized between 5 and 25 and persisted locally. */
  if (config.SHOW_ACTIVITY_WIDGET) {
    const viewerKey = 'kobre_live_viewers_v3';
    const minViewers = 5;
    const maxViewers = 25;
    const clamp = value => Math.max(minViewers, Math.min(maxViewers, value));

    const readViewerState = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(viewerKey) || 'null');
        if (parsed && Number.isInteger(parsed.viewers) && parsed.viewers >= minViewers && parsed.viewers <= maxViewers) return parsed;
      } catch (_) {}
      return {
        viewers: Math.floor(Math.random() * (maxViewers - minViewers + 1)) + minViewers,
        updatedAt: Date.now()
      };
    };

    let viewerState = readViewerState();

    const renderViewers = () => {
      $$('[data-activity]').forEach(element => { element.hidden = false; });
      $$('[data-activity-count]').forEach(element => { element.textContent = String(viewerState.viewers); });
    };

    const saveViewerState = () => {
      viewerState.updatedAt = Date.now();
      try { localStorage.setItem(viewerKey, JSON.stringify(viewerState)); } catch (_) {}
    };

    const moveViewers = () => {
      if (document.visibilityState === 'hidden') return;
      const moves = [-3, -2, -1, 1, 2, 3];
      let next = clamp(viewerState.viewers + moves[Math.floor(Math.random() * moves.length)]);
      if (next === viewerState.viewers) {
        next = viewerState.viewers <= minViewers ? minViewers + 1 : maxViewers - 1;
      }
      viewerState.viewers = next;
      saveViewerState();
      renderViewers();
    };

    renderViewers();
    saveViewerState();

    const scheduleNextViewerMove = () => {
      const delay = 8000 + Math.floor(Math.random() * 9000);
      window.setTimeout(() => {
        moveViewers();
        scheduleNextViewerMove();
      }, delay);
    };
    scheduleNextViewerMove();
  }

  /* 15-minute shipping countdown. The deadline is saved so refreshing does not reset it. */
  const countdownNodes = $$('[data-countdown]');
  if (countdownNodes.length && config.FREE_SHIPPING_ENABLED) {
    const countdownKey = 'kobre_shipping_countdown_15m_v3';
    let endAt = 0;

    try {
      const saved = Number(localStorage.getItem(countdownKey) || 0);
      if (saved > Date.now()) endAt = saved;
    } catch (_) {}

    if (!endAt) {
      endAt = Date.now() + (15 * 60 * 1000);
      try { localStorage.setItem(countdownKey, String(endAt)); } catch (_) {}
    }

    countdownNodes.forEach(node => { node.hidden = false; });
    $$('[data-countdown-demo]').forEach(node => { node.hidden = true; });

    const renderClock = () => {
      const remainingMs = Math.max(0, endAt - Date.now());
      const totalSeconds = Math.ceil(remainingMs / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      const value = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      $$('[data-clock]').forEach(node => { node.textContent = value; });

      if (remainingMs <= 0) {
        try { localStorage.removeItem(countdownKey); } catch (_) {}
        countdownNodes.forEach(node => { node.hidden = true; });
        return false;
      }
      return true;
    };

    if (renderClock()) {
      const interval = window.setInterval(() => {
        if (!renderClock()) window.clearInterval(interval);
      }, 1000);
    }
  }

  /* Preorder summary modal. The item is added only after Continue to Checkout. */
  const productForm = $('[data-kobre-product-form]');
  const checkoutDialog = $('#checkout-preview');
  const continueCheckout = $('[data-continue-checkout]');
  let pendingForm = null;

  function updateCheckoutPreview(form) {
    if (!form) return;
    const quantityInput = $('input[name="quantity"]', form);
    const quantity = Math.max(1, Number(quantityInput?.value || 1));
    const unitPrice = Number(form.dataset.unitPriceCents || Math.round(Number(config.PRODUCT_PRICE || 0) * 100));
    const comparePrice = Number(form.dataset.comparePriceCents || 0);
    const subtotal = unitPrice * quantity;
    const compareSubtotal = comparePrice * quantity;

    $$('[data-preview-quantity]').forEach(node => { node.textContent = String(quantity); });
    $$('[data-preview-subtotal]').forEach(node => { node.textContent = formatMoney(subtotal); });
    $$('[data-preview-compare]').forEach(node => {
      node.textContent = compareSubtotal > subtotal ? formatMoney(compareSubtotal) : '';
      node.hidden = !(compareSubtotal > subtotal);
    });
  }

  productForm?.addEventListener('submit', event => {
    event.preventDefault();
    if (!productForm.checkValidity()) {
      productForm.reportValidity();
      return;
    }
    pendingForm = productForm;
    updateCheckoutPreview(productForm);
    const error = $('[data-checkout-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    openDialog(checkoutDialog);
  });

  continueCheckout?.addEventListener('click', async () => {
    if (!pendingForm) return;
    const error = $('[data-checkout-error]');
    const originalText = continueCheckout.textContent;
    continueCheckout.disabled = true;
    continueCheckout.textContent = 'ADDING PREORDER…';

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(pendingForm)
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this preorder to cart.');

      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          $$('.cart-button span').forEach(node => { node.textContent = String(cart.item_count || 0); });
        }
      } catch (_) {}

      window.location.assign('/checkout');
    } catch (err) {
      if (error) {
        error.textContent = err instanceof Error ? err.message : 'Unable to continue to checkout.';
        error.hidden = false;
      }
      continueCheckout.disabled = false;
      continueCheckout.textContent = originalText;
    }
  });

  syncImage();
})();
